import { SeriesGroupCategory } from '../../pages/home'
import { GetCandlesRequestV2 } from '../../proto/generated/candle-data-depot'
import { TimeBucket_TimeSeries } from '../../proto/generated/common'
import { Security } from '../../proto/generated/security'
import { SuperChartConfiguration_TimeBucket } from '../../proto/generated/superchart-page'
import { getNewPanesConfig } from '../../util/chart'
import { convertExpressionToDisplayExpression } from '../../util/expression'
import { getSecurityKey } from '../../util/security'
import { ChartConfig, ChartMode } from './chart.typings'

export const updatePrimarySecurities = (config: ChartConfig, securities: Security[], mode: ChartMode, expression: string, expressionName: string) => {
    const newConfig = getNewPanesConfig(config.panes, config.panesConfig, config.seriesGroups, config.series)
    if(securities.length) {
        Object.values(newConfig.seriesGroups).forEach((sg) => {
            const securityList = sg.category !== SeriesGroupCategory.SERIES_COMPARABLE_SECURITY ? securities.map(v => getSecurityKey(v.exchange, v.code)) : sg.securityList
            const name = sg.primary ? (mode === 'EXPRESSION' ? expressionName ?? convertExpressionToDisplayExpression(expression!, securities) : securities[0].symbol || '') : sg.name
            newConfig.seriesGroups[sg.id] = {
                ...sg,
                securityList,
                name
            }
            const sid = sg.series[0]
            const series = newConfig.series[sid]
            if (sg.primary && series) {
                newConfig.series[sid] = {
                    ...series,
                    name
                }
            }
        })
    }
    return newConfig
}

export const getCandleRequestV2 = (
    backwardCandleCount: number,
    forwardCandleCount: number,
    security: Security,
    timeBucket: SuperChartConfiguration_TimeBucket,
    referenceTime: number,
    accurateLastCandle: boolean = false,
    dontGiveExtraCandles: boolean = false
): GetCandlesRequestV2 => {
    return {
        backwardCandleCount,
        dontGiveExtraCandles: (import.meta.env.MODE ?? '') === 'production' ? dontGiveExtraCandles : true,
        forwardCandleCount: forwardCandleCount,
        security,
        timeBucket: {
            timeSeries: timeBucket.timeSeries,
            value: timeBucket.timeValue
        },
        referenceTime,
        // accurateLastCandle
    } as any
}

export const getTimeWidthInSeconds = (timeBucket: SuperChartConfiguration_TimeBucket): number => {
    let timeWidth: number = timeBucket.timeValue
    switch (timeBucket.timeSeries) {
        case TimeBucket_TimeSeries.SECOND: {
            timeWidth *= 1
            break
        }
        case TimeBucket_TimeSeries.MINUTE: {
            timeWidth *= 60
            break
        }
        case TimeBucket_TimeSeries.HOUR: {
            timeWidth *= (60 * 60)
            break
        }
        case TimeBucket_TimeSeries.DAY: {
            timeWidth *= (60 * 60 * 24)
            break
        }
        case TimeBucket_TimeSeries.WEEK: {
            timeWidth *= (60 * 60 * 24 * 7)
            break
        }
        default: {
            timeWidth *= 1
        }
    }
    return timeWidth
}

export const getTimeWidthInMilliSeconds = (timeBucket: SuperChartConfiguration_TimeBucket): number => getTimeWidthInSeconds(timeBucket) * 1000
